import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import { Observable, ObservedValueOf } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgileIntegrationService {

  constructor(private http: HttpClient) { }

  getEventListPrices(eventId: number, promoCode: string): Observable<any>{
    const url = environment.apiURL + 'api/v2/agiletix/event/list-prices/' + eventId +
    ((promoCode === undefined || promoCode === null || promoCode === '') ? '' : '/' + promoCode);
    console.log('+++++++' + url);
    return this.http.get(url, { withCredentials: true });
  }

  addToCart(eventId, showingId, eventTierId, promoCode): Observable<any> {
    const url = environment.apiURL + 'api/v2/agiletix/ticket/buy/' + eventId + '/' + showingId + '/' +
    eventTierId + '/' + 1  + ((promoCode === undefined || promoCode === null || promoCode === '') ? '' : '/' + promoCode);
    console.log('++++++++' + url);
    return this.http.get(url, { withCredentials: true });
  }

  fetchCartInfo(): Observable<any> {
    const url = environment.apiURL + 'api/v2/agiletix/cart/info';
    return this.http.get(url, { withCredentials: true });
  }

  deleteTicket(body: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*'
      }),
      withCredentials: true
    };
    const url = environment.apiURL + 'api/v2/agiletix/tickets/delete';
    return this.http.post(url, body, httpOptions);
  }

  fetchTickets(): Observable<any> {
    const url = environment.apiURL + 'api/v2/agiletix/event/tickets';
    return this.http.get(url, { withCredentials: true });
  }

  getAllAccessListPrices(promoCode: string): Observable<any>{
    const url = environment.apiURL + 'api/v2/agiletix/all-access-pass/list-prices/' +
    ((promoCode === undefined || promoCode === null) ? '' : promoCode);
    return this.http.get(url, { withCredentials: true });
  }

}
